



export const Regras = () => {

    return (
        <div>
            
            <h1>Regras</h1>
            
            
        </div>



    )
}